<!-- Chat button - always visible when panel is closed -->
@if (!isExpanded) {
  <div class="chat chat-btn" (click)="toggleChat()">AI</div>
}

<!-- Chat panel - always present but positioned off-screen when closed -->
<div class="chat-panel" [class.panel-closed]="!isExpanded" [style.width.px]="panelWidth">
  <!-- Resize handle -->
  <div class="resize-handle" (mousedown)="startResize($event)" title="Drag to resize"></div>

  <div class="chat-header">
    @if (state === ChatState.Ready) {
      <button class="btn btn-icon-only" (click)="newChat()" tooltip="Start new chat">
        <svg-icon key="plus" size="xs" />
      </button>
    }
    <h2 (click)="reloadChat()">AI Agent</h2>
    <button class="btn btn-icon-only right" (click)="toggleChat()" tooltip="Close chat">
      <svg-icon key="close" size="xs" />
    </button>
  </div>
  @if (state === ChatState.Loading) {
    <div class="chat-content">
      <div class="loading">Loading chat...</div>
    </div>
  }

  @if (state === ChatState.Error) {
    <div class="chat-content">
      <div class="error">
        Failed to load chat. Please try again later.
        <button class="btn btn-primitive" (click)="toggleChat(true)">Retry</button>
      </div>
    </div>
  }

  @if (state === ChatState.Ready) {
    <div class="chat-content">
      <div class="messages" #messagesContainer>
        @for (message of messages; track $index) {
          <p class="message {{ message.role }}" [innerHTML]="message.text"></p>
        }
      </div>
    </div>

    <div class="chat-footer">
      @if (showLoadingTodos) {
        <div class="loading-info todo">
          <div class="todos-list">
            @for (todo of todos; track $index) {
              <div class="todo-item">
                @if (todo.status === 'done') {
                  <svg-icon key="done-circle" size="sm" class="todo-icon done" />
                }
                @if (todo.status === 'in_progress') {
                  <svg-icon key="navigation-right-circle-1" size="sm" class="todo-icon in-progress" />
                }
                @if (todo.status === 'pending') {
                  <svg-icon key="subtract-circle" size="sm" class="todo-icon pending" />
                }
                <span class="todo-content">{{ todo.content }}</span>
              </div>
            }
          </div>
        </div>
      }
      @if (showLoadingInfo) {
        <div class="loading-info">
          <div class="spinner-border"></div>
          <div class="labels">
            <label class="stage">{{ stage }}</label>
            <label class="message">{{ info }}</label>
          </div>
        </div>
      }

      @if (showContextInfo) {
        <div class="context-info">
          <label class="header">Context:</label>
          @if (contextProcessLabel) {
            <label class="process"><b>Process:</b> {{ contextProcessLabel }}</label>
          }
          @if (contextQueueLabel) {
            <label class="queue"><b>Queue:</b> {{ contextQueueLabel }}</label>
          }
        </div>
      }
      <div class="toolbar" [class.disabled]="toolbarDisabled">
        <div class="message-input-container">
          <textarea
            class="message form-control"
            rows="3"
            [disabled]="sendingMessage || currentQuestion !== null"
            [(ngModel)]="currentMessage"
            placeholder="Ask a question about your data"
            (keydown)="onKeyDown($event)"> </textarea>
          <button class="btn btn-send" [disabled]="sendingMessage || currentQuestion !== null || !currentMessage.trim()" (click)="sendMessage()">
            <svg-icon key="arrow-up" size="sm" />
          </button>
        </div>
      </div>

      @if (examples.length > 0) {
        <div class="examples">
          @for (example of examples; track example) {
            <button class="btn btn-secondary" [disabled]="sendingMessage || currentQuestion !== null" (click)="sendExampleMessage(example)">
              {{ example }}
            </button>
          }
        </div>
      }
    </div>
  }
</div>
